import { FC } from 'react'
import { useSubmitViolationItemDecision } from 'hooks'
import { ApproveRisk } from './ApproveRisk'
import { Box } from '@mui/material'
import { RejectRisk } from './RejectRisk'
import { DoNothing } from './DoNothing'

export const ViolatingItemDecision: FC<{ item: any; decisions: any }> = (
    props,
) => {
    const { item, decisions } = props

    const { mutateAsync: submitRiskDecision, isLoading: isSubmitting } =
        useSubmitViolationItemDecision(
            'RequestItems',
            item.businessRequestId,
            item.id,
        )

    return (
        <Box>
            {decisions && (
                <Box style={{display: 'flex'}}>
                    {decisions.map((d: any) => (
                        <Box component="span" key={d.decisionId} marginX="1.2rem">
                            {d.decisionAction === 'Continue' ? (
                                <Box sx={{ '& button': { minHeight: '4.7rem' } }}>
                                    <ApproveRisk
                                        currentApprovalStepId={
                                            item.currentApprovalStepId
                                        }
                                        onSubmit={(value) => {
                                            const approveReq = {
                                                ...value,
                                                stepId: item.currentApprovalStepId,
                                                decisionId: d.decisionId,
                                            }
                                            return submitRiskDecision(
                                                approveReq,
                                            )
                                        }}
                                        decisionFriendlyName={
                                            d.decisionFriendlyName
                                        }
                                        isLoading={isSubmitting}
                                    />
                                </Box>
                            ) : d.decisionAction === 'DoNothing' ? (
                                <Box sx={{ '& button': { minHeight: '4.7rem' } }}>
                                    <DoNothing d={d} item={item} />
                                </Box>
                            ) : (
                                <Box sx={{ '& button': { minHeight: '4.7rem' } }}>
                                    <RejectRisk d={d} item={item} />
                                </Box>
                            )}
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    )
}
